import { Component, ElementRef, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SearchTable } from "../get-table-filter/get-table-filter.component";

export interface Tab {
	id: string; // must be unique
	defaultActive: boolean;
	label: string;
	data: SearchTable;
}

@Component({
	selector: "app-simple-tabs",
	templateUrl: "./simple-tabs.component.html",
	styleUrls: ["./simple-tabs.component.scss"],
})
export class SimpleTabsComponent implements OnInit {
	@Input()
	tabs: Array<Tab> = [];

	@Output()
	clicked = new EventEmitter<Tab>();

	@Output()
	firstTabShiftTab = new EventEmitter<void>();

	@Output()
	lastTabTab = new EventEmitter<void>();

	activeTab: Tab;

	constructor(private readonly el: ElementRef<HTMLElement>) {}

	ngOnInit() {
		this.activeTab = this.tabs.find(tab => tab.defaultActive);
	}

	onClickTab(tab: Tab, event: Event) {
		event.stopPropagation();

		this.activeTab = tab;

		this.clicked.emit(tab);
	}

	onTabKeydown(event: KeyboardEvent, tab: Tab) {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			this.onClickTab(tab, event);
			this.focusActiveTab();
			return;
		}
		if (event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "Home" || event.key === "End") {
			event.preventDefault();
			let nextIdx: number;
			const currentIdx = this.tabs.findIndex(t => t.id === tab.id);
			if (event.key === "ArrowRight") {
				nextIdx = (currentIdx + 1) % this.tabs.length;
			} else if (event.key === "ArrowLeft") {
				nextIdx = (currentIdx - 1 + this.tabs.length) % this.tabs.length;
			} else if (event.key === "Home") {
				nextIdx = 0;
			} else {
				nextIdx = this.tabs.length - 1;
			}
			const nextTab = this.tabs[nextIdx];
			this.activeTab = nextTab;
			this.clicked.emit(nextTab);
			this.focusTabByIndex(nextIdx);
			return;
		}
		if (event.key !== "Tab") return;

		// With roving tabindex, only the active tab is focusable via Tab.
		// Forward Tab should leave the tablist forward; Shift+Tab should leave backward.
		event.preventDefault();
		if (event.shiftKey) {
			this.firstTabShiftTab.emit();
		} else {
			this.lastTabTab.emit();
		}
	}

	trackById(_index: number, tab: Tab): string {
		return tab.id;
	}

	private focusActiveTab() {
		const idx = this.tabs.findIndex(t => this.activeTab && t.id === this.activeTab.id);
		if (idx !== -1) {
			this.focusTabByIndex(idx);
		}
	}

	private focusTabByIndex(index: number) {
		setTimeout(() => {
			const tabEls = this.el.nativeElement.querySelectorAll<HTMLElement>(".tab");
			tabEls[index]?.focus();
		});
	}
}
